export function buildEthereumContractUrl(contractAddress: string): string {
  return `${ETH_NETWORK_EXPLORER_URL}address/${contractAddress}`;
}
